import React from 'react';
import { ESignPreferenceEditTemplate } from 'themes/application/esign-preference/pages';
import { observer } from 'mobx-react';
import { ESignPreferenceEditViewStore } from 'application/esign-preference/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ESignPreferenceEditViewStore(rootStore), 'eSignPreferenceEditViewStore')
@observer
class ESignPreferenceEdit extends React.Component {
    render() {
        return <ESignPreferenceEditTemplate {...this.props} />
    }
}

export default ESignPreferenceEdit;
